var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.769 100",
    width: 50,
    height: 50,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.794,13.437L73.398,0.989c-1.713-1.732-5.124-1.126-7.585,1.328L54.524,13.574H15.713v15.703H0V100h55.006V84.284h15.717              V34.674l13.724-13.672C86.895,18.554,87.513,15.156,85.794,13.437z M41.92,58.567l-17.135,6.94l-3.682-3.698L28.102,44.7              L41.92,58.567z M18.802,16.66h32.624l-12.66,12.617H18.802V16.66z M3.089,96.907V32.37h32.572l-9.955,9.921l-10.638,25.99              c-1.228,2.981,0.231,4.44,3.203,3.249l26.045-10.554l7.598-7.565v43.496H3.089z M67.637,81.191H55.006V50.332l12.631-12.578V81.191z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.2a5f220bcad5f547ce89fb80fe8d9fc0.svg";
export { ForwardRef as ReactComponent };